module.exports = __webpack_public_path__ + "static/media/om_beard_scruff_diamond__v_shadow.3e64d8c1.png";